<template>
  <div class="paddleContainer"></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  async mounted() {
    const email = this.$route.query.email
    const zip = this.$route.query.zip
    const countryCode = this.$route.query.countryCode
    const utmSource = this.$route.query.utmSource
    const parsedCustomData = this.$route.query.customData
      ? JSON.parse(this.$route.query.customData) || {}
      : {}
    const checkoutCustomData = { account_email: email, ...parsedCustomData }
    const allowedPaymentMethods = this.$route.query.allowedPaymentMethods.split(
      ','
    )
    Paddle.Checkout.open({
      items: [{ priceId: 'pri_01jzapxsxjp0n38kesee3e0fgg', quantity: 1 }],
      //customData: checkoutCustomData,
      settings: {
        theme: 'light',
        variant: 'one-page',
        displayMode: 'inline',
        frameTarget: 'checkout-container',
        frameInitialHeight: '450',
        frameStyle:
          'width: 100%; min-width: 312px; background-color: transparent; border: none;',
        allowedPaymentMethods: 'apple_pay',
        showAddDiscounts: false,
        showAddTaxId: false,
        allowLogout: false
      },
      customer: {
        customData: {
          utm_source: utmSource,
          account_email: email
        },
        email: email,
        address: {
          countryCode: countryCode,
          postalCode: zip
        }
      }
    })
  }
}
</script>
<style lang="scss">
.paddleContainer {
}
</style>
